/**
 * @namespace Stores
 * @category Stores
 * @module location-alerts
 * */

import moment from 'moment'
import cache from '@/utils/cache'
import api from '@/api'
import { acknowledgeAlert } from '@/api/alerts-api'
import searchService from '@/services/search-service'
function newAlertsState() {
  return {
    alerts: [],
  }
}
export default {
  state: newAlertsState(),
  getters: {
    getAlerts(state) {
      return state.alerts
    },
    getUnreadAlerts: (state) => {
      return state.alerts.filter((alert) => alert.statut < 2).length
    },
    findAlertById: (state) => (id) => {
      return state.alerts.find((alert) => alert.message_id === id)
    },
    findAlertByLatlng: (state) => (lat, lng) => {
      if (lat && lng) {
        return state.alerts.find(
          (alert) => alert.latitude === lat && alert.longitude === lng
        )
      }
      return null
    },
  },
  mutations: {
    setAlerts(state, alerts) {
      state.alerts = alerts
    },
    resetAlertsState(state) {
      state = {
        ...newAlertsState(),
      }
    },
  },
  actions: {
    async acknowledgeAlert({ commit }, messageId) {
      await acknowledgeAlert(messageId)
    },
    /**
     * @TODO Refactor/Reuse alerts-api.js helpers intead
     */
    async getVehicleAlerts(
      { commit, dispatch },
      { vehicleId, datetimeFrom } = {}
    ) {
      commit('resetAlertsState')
      if (!vehicleId) {
        throw new Error('FETCH_ALERTS__INVALID_VEHICLE_ID')
      }
      let userInfos = await cache.getItem('user_infos')
      let userId = userInfos.userId
      let date = (datetimeFrom && moment(datetimeFrom)) || moment()
      let from = searchService.getRangeTimeSelected(
        date,
        'YYYY-MM-DD HH:mm:ss'
      ).start
      let to = searchService.getRangeTimeSelected(
        date,
        'YYYY-MM-DD HH:mm:ss'
      ).end
      let data = (
        await api.v2.get(
          `/v2/cdm/messages_alertes?vehicule_id=${vehicleId}&dateheure_debut=${from}&dateheure_fin=${to}&utilisateur_id=${userId}`
        )
      ).data

      data = data.filter((item) => {
        return !!item.latitude && !!item.longitude
      })
      commit('setAlerts', data)
      setAlertMarkersIntoMapStore(data, dispatch)
    },
  },
}

function setAlertMarkersIntoMapStore(data, dispatch) {
  let normalizedData = []
  data.forEach((elem) => {
    normalizedData.push({
      lat: elem.latitude,
      lng: elem.longitude,
      type: elem.type,
      date_creation: elem.date_creation,
      message: elem.message,
      address: elem.adresse,
    })
  })

  dispatch(
    'simpliciti_map/setDataset',
    {
      type: 'alertsMarkers',
      data: normalizedData,
    },
    { root: true }
  )
}
